import React from 'react';
import classNames from 'classnames';
import './SecondKillComp.less';
import * as PropType from '../../../components/common/propType';
import autobind from 'autobind-decorator';

type SecondKillCompSize = 'lg' | 'sm' | 'xs' | 'medium';
type SecondKillCompText = '开始抢购' | '结束抢购' | '开始秒杀' | '结束秒杀' | '恢复原价' | '开始售卖' | undefined | '';

interface ISecondKillCompPropType extends PropType.RadiusPropType, PropType.RectPropType, PropType.StylePropType{
    prefixCls?: string;
    size?: SecondKillCompSize;
    text?: SecondKillCompText;
    date?: string;
}

/**
 * 秒杀组件
 * @class SecondKillComp
 * @extends {React.Component<ISecondKillCompPropType, any>}
 */
class SecondKillComp extends React.Component<ISecondKillCompPropType, any> {
    static defaultProps = {
        prefixCls: 'second-kill',
        size: 'lg',
        text: '开始抢购',
        radius: false,
        date: '0月0日 00:00:00'
    };

    @autobind
    private _bg(text): void {
        const {prefixCls} = this.props;
        const bgObj: any = {
            '开始秒杀': `${prefixCls}-msg-bg1`,
            '结束秒杀': `${prefixCls}-msg-bg3`,
            '恢复原价': `${prefixCls}-msg-bg2`,
            '开始抢购': `${prefixCls}-msg-bg2`,
            '结束抢购': `${prefixCls}-msg-bg2`,
            '开始售卖': `${prefixCls}-msg-bg2`,
        };
        return bgObj[text];
    }

    @autobind
    private _border(text): void {
        const {prefixCls} = this.props;
        const bgObj: any = {
            '开始秒杀': `${prefixCls}-border1`,
            '结束秒杀': `${prefixCls}-border1`,
            '恢复原价': `${prefixCls}-border2`,
            '开始抢购': `${prefixCls}-border2`,
            '结束抢购': `${prefixCls}-border2`,
            '开始售卖': `${prefixCls}-border2`,
        };
        return bgObj[text];
    }

    render() {
        const {prefixCls, size, className, text, radius, date} = this.props;
        const style: any = PropType.getStyle(this.props);
        let clsName = classNames(
            className,
            `${prefixCls}`,
            this._border(text),
            `${prefixCls}-${size}`,{
                [`${prefixCls}-radius`]: radius,
            }
        );
        return (
            <div className={clsName} style={style}>
                <span className={`${prefixCls}-time`}>{date}</span>
                <span className={`${prefixCls}-msg ` + this._bg(text)}>{text}</span>
            </div>
        );
    }
}

export default SecondKillComp;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/activityComp/secondKillComp/SecondKillComp.tsx